export const fetchCityIp = async (ip) => {
  try {
    const response = await fetch("https://freegeoip.app/json/" + ip).then((j) =>
      j.json()
    );
    return response;
  } catch (e) {
    console.log(e);
    
  }
};

export const translateCity = async (str) => {
  try {
    const response = await fetch("/translate/" + str).then((j) => j.json());
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const fetchCityByCoordinates = async (str) => {
  try {
    const response = await fetch("/getCity/" + str).then((j) => j.json());
    return response;
  } catch (e) {
    console.log(e);
  }
};
